import * as React from 'react'
import { ComponentClass, FunctionComponent, ReactElement, useMemo } from 'react'
import { FormikContextType } from 'formik'
import { Field } from '@fluentui/react-components'
import { FieldProps } from '@fluentui/react-field'
import { useTranslation } from 'react-i18next'

type FormikFieldProps<CP> = FieldProps & {
    labelKey?: string
    context: FormikContextType<any>
    fieldName: string
    component: FunctionComponent<CP> | ComponentClass<CP>
    componentProps: CP
}

export default function FormikField<CP>(props: FormikFieldProps<CP>): ReactElement {
    const { t: translate } = useTranslation()

    const validationMessage = useMemo(
        () => props.context.errors[props.fieldName] as string,
        [props.context.values, props.context.errors],
    )
    const validationState = useMemo(
        () => (props.context.errors[props.fieldName] ? 'error' : 'none'),
        [props.context.values, props.context.errors],
    )

    return (
        <Field
            label={props.labelKey ? translate(props.labelKey) : undefined}
            {...props}
            validationMessage={validationMessage}
            validationState={validationState}
        >
            <props.component
                // onBlur={props.context.handleBlur(props.fieldName)}
                // onChange={props.context.handleChange(props.fieldName)}
                {...props.componentProps}
            />
        </Field>
    )
}
